module.exports = __webpack_public_path__ + "img/luminance.5a0ff15f.png";